import {
  dictionaryTypeOptionsTranslation,
  DictionaryTypeOptionsTranslation,
} from '@/assets/locales/utils/dictionaries/dictionaries.translation.pl.ts';

export type AddDictionaryEntryDialogTranslation = {
  button: {
    add: string;
    cancel: string;
  };
  content: string;
  dictionaryTypeOptions: DictionaryTypeOptionsTranslation;
  title: string;
};

export const addDictionaryEntryDialogTranslation: AddDictionaryEntryDialogTranslation = {
  button: {
    add: 'Dodaj',
    cancel: 'Anuluj',
  },
  content: "Wykonanie tej operacji doda wartość '{{name}}' do słownika '{{dict}}'",
  dictionaryTypeOptions: dictionaryTypeOptionsTranslation,
  title: 'Potwierdź dodanie nowej wartości',
};
